<template>
  <div v-if="myPages || userLoggedIn" class="flex justify-between items-center w-full">
    <a :href="login?.logOutButton?.url" class="flex p-2 w-full cursor-pointer group button-std" @click.prevent="logOut">
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block ml-2" width="16px" height="16px" viewBox="0 0 16 16">
        <path
          class="group-hover:fill-black fill-white"
          d="m12.444 4.444-1.253 1.254 1.405 1.413H5.333V8.89h7.263l-1.405 1.404 1.253 1.263L16 8l-3.556-3.556ZM1.778 1.778H8V0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16H8v-1.778H1.778V1.778Z"
          fill="#fff" />
      </svg>
      <span class="ml-2">{{ login?.logOutButton?.text }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'EllevioWebLogOutButton',
  props: {
    login: {
      type: Object,
      default: () => {}
    },
    myPages: {
      type: Boolean,
      default: false
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    logOut() {
      sessionStorage.removeItem('ellevio')
      sessionStorage.removeItem('ellevio-chart')

      window.location.href = this.login.logOutButton.url
    },
    closeLoginMenu() {
      this.$emit('close-login-menu')
    }
  }
}
</script>
